import { Link } from "@mui/material";
import { darken } from "@mui/material/styles";

export function createJsxLink(
  text: string,
  href: string,
  config?: {
    target: string;
  }
) {
  const baseColor = "#3d5afe";

  return (
    <Link
      href={href}
      target={config?.target || "_blank"}
      sx={{
        color: darken(baseColor, 0.3),
        fontWeight: "500",
        cursor: "pointer",
        transition: "all 0.2s ease-in-out",
        position: "relative",
        textDecoration: "none",
        "&:hover": {
          color: baseColor,
          textDecoration: "underline",
          textUnderlineOffset: "2px",
        },
      }}
    >
      {text}
    </Link>
  );
}
